import Cookies from 'js-cookie';
import './Main.css';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-hot-toast';
import axios, { isCancel } from 'axios';
import { useState, useEffect,useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { FaFacebook, FaInstagram, FaLinkedin,FaLink,FaWhatsapp } from 'react-icons/fa';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { QRCodeCanvas } from 'qrcode.react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
function Main() {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [UrlSHORTcOUNT, setUrlSHORTcOUNT] = useState(0);
  const [url, seturl] = useState("");
  const [check, setcheck] = useState(false);
  const [shortUrl, setShortUrl] = useState('');
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [qrimageurl, setqrimageurl] = useState('');
  const [data, setdata] = useState([]);
  const [uniqueId, setuniqueId] = useState("");
  const apiUrl = `https://url-shortener-backend-eight-bice.vercel.app/api/url`;

  // Main function to shorten the URL
  const submiturl = async () => {
    const token = Cookies.get('authToken');
    const storedUrlCount = localStorage.getItem('UrlSHORTCOUNT');
    const urlCount = storedUrlCount ? Number(storedUrlCount) : 0;
    setUrlSHORTcOUNT(urlCount);

    let uniqueIds = localStorage.getItem('userid') || uuidv4(); // Generate or retrieve unique ID
    setuniqueId(uniqueIds);

    if (urlCount < 5 || token) { // Limit URL count to 5 if no token
      try {
        const res = await axios.post(`${apiUrl}/genrateshorturl`, {
          userid: uniqueIds,
          url: url,
        });

        if (res.status === 200) {
          setShortUrl(res.data); // Update short URL state
          localStorage.setItem('userid', uniqueIds);
          const newUrlCount = urlCount + 1;
          localStorage.setItem('UrlSHORTCOUNT', newUrlCount); 
          setUrlSHORTcOUNT(newUrlCount);
          seturl(''); // Clear input field
        }
       if(res.status===200){
        setqrimageurl(res.data)
       }
      } catch (err) {

        if(err.response && err.response.status === 400){
          console.log("not formet")
          toast.error("Wrong URL");
        }
        else
        console.error("Error:", err);
      }
    } else {
      toast.error("You have reached the limit of 5 short URLs");
    }
  };

  // Fetch existing short URLs
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userid = localStorage.getItem('userid');
        const response = await axios.get(`${apiUrl}/getrecords?id=${userid}`);
        if (response.status === 200) {
          setdata(response.data);
        }
       
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [shortUrl]); // Fetch data on short URL update

  const inputevent = (event) => {
    seturl(event.target.value);
  };

  // Handle clipboard switch to auto-paste URL
  const handleSwitchChange = () => {
    setIsSwitchOn((prevState) => !prevState);
  };

  // Read from clipboard when switch is on
  useEffect(() => {
    if (isSwitchOn && navigator.clipboard) {
      navigator.clipboard.readText()
        .then((text) => seturl(text))
        .catch((err) => console.error('Failed to read clipboard contents:', err));
    }
  }, [isSwitchOn]);
//copy text 

//share on social media 
const handleShare = (platform) => {
  // First copy the URL to clipboard
  navigator.clipboard.writeText(shortUrl)
    .then(() => {
      console.log('URL copied to clipboard');
      
      // Then open the share dialog for the specific platform
      let shareUrl;
      const encodedUrl = encodeURIComponent(`${apiUrl}/${shortUrl.shortUrl}`);
      
      switch(platform) {
        case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
          break;
      
        case 'instagram':
          // Instagram doesn't have direct share, so we'll just copy
          alert('Instagram link copied! Paste it in your Instagram post');
          return;
        case 'linkedin':
          shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
          break;
        case 'whatsapp':
          shareUrl = `https://wa.me/?phone=&&text=${encodedUrl}`;
          break;
        
        default:
          return;
      }
      
      window.open(shareUrl, '_blank');
    })
    .catch(err => {
      console.error('Failed to copy URL: ', err);
    });
};
const qrRef = useRef();
//qr download 
const handleDownload = () => {


 
    const canvas = qrRef.current.querySelector('canvas');
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');

    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'qr-code.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  return (
    <div>
      <div className='main-container'>
        <h1><span>Shorten Your Loooong Links :)</span></h1>
        <p className="px-4 px-md-6 py-2">Linkly is an efficient and easy-to-use URL shortening service that streamlines your online experience.</p>
        {shortUrl && (
          <div className="mt-3 d-flex justify-content-center align-items-center  mb-3" style={{ marginLeft: "25px" }}>
            <h5>Short URL:</h5>
            <a href={`${apiUrl}/${shortUrl.shortUrl}`} target="_blank" rel="noopener noreferrer">{`${apiUrl}/${shortUrl.shortUrl}`}</a>
         
        <CopyToClipboard text={`${apiUrl}/${shortUrl.shortUrl}`} onCopy={() => setCopied(true)}>
        <button 
          
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#6c757d',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
          title="Copy link"
        > 
          <FaLink size={25} style={{  marginLeft: '20px' }} />
        {copied  ?  <span style={{ fontSize: '0.7rem', marginLeft: '20px' }}>Copied!</span> :  <span style={{ fontSize: '0.7rem', marginLeft: '20px' }}>Copy</span>} 
        </button>
      </CopyToClipboard>
     
      <div ref={qrRef} style={{ cursor: 'pointer', marginLeft:"20px" }} onClick={handleDownload}>
      <div className="blinking-arrow" onClick={handleDownload}>
        &#8595; {/* This is a downward arrow symbol */}
      </div>
      <QRCodeCanvas
        value={qrimageurl}
        size={60}
        level="H"
        includeMargin={true}
      />
        
    </div>
          </div>
        )}
        <div className="search">
          <input 
            type="text"
            placeholder="Paste Here..."
            className="input-field"
            value={url}
            onChange={inputevent}
          />
          <button onClick={submiturl} className="search-btn">
            Short Now!
          </button> 
        </div>

        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50px',
            }}
          >
            <Form>
              <Form.Check 
                type="switch"
                checked={isSwitchOn}
                onChange={handleSwitchChange}
                id="custom-switch"
                label={<span style={{ color: '#fff' }}>Auto Paste from Clipboard</span>}
              />
            </Form>
          </div>
          <p className="px-4 px-md-6 py-2">
            You can create <span style={{ color: "rgb(221, 5, 156)" }}>05</span> more links. Register now to enjoy Unlimited usage.
          </p>
        </div>

        <div className="table-responsive">
          <table style={{ border: "0" }}>
            <thead>
              <tr>
                <th>Short Link</th>
                <th>Original Link</th>
                <th>Clicks</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody style={{ border: "0" }}>
              {data.sort((a, b) => new Date(b.date) - new Date(a.date)).map((item) => (
                <tr key={item._id}>
                  <td className="url-cell">
                    <a href={`${apiUrl}/${item.shortUrl}`} target="_blank" rel="noopener noreferrer">{`${apiUrl}/${item.shortUrl}`}</a>
                  </td>
                  <td className="url-cell">
                  <a href={`${item.originalUrl}`} target="_blank" rel="noopener noreferrer">
  <img
    src={`https://www.google.com/s2/favicons?sz=64&domain=${new URL(item.originalUrl).hostname}`}
    alt="favicon"
    style={{ width: '16px', height: '16px', marginRight: '5px' }}
  />
  {item.originalUrl}
</a>
                  </td>
                  <td>{item.noofclicks}</td>
                  <td style={{ display: "flex", width: "200px" }}>{new Date(item.date).toDateString()}</td>
                 
                
                </tr>
              ))}
            </tbody>
          </table>

        </div>
        <div className='register-in-main'>
          <a href="/register">Register Now</a><span> to Enjoy Unlimited History</span>
          <img src={qrimageurl}></img>
        </div>
      </div>
      <div>

<h3 style={{ 
  marginBottom: '15px', 
  textAlign: 'center',
  color: '#fff',
  marginTop: '50px',
  fontSize: '1.2rem'
}}>
  Share On Social Media
</h3>
  </div>
  <div className="social-icons">
      <a href="#" onClick={(e) => { e.preventDefault(); handleShare('facebook'); }} style={{ color: '#4267B2' }}>
        <FaFacebook size={40} />
      </a>
      

      <a href="#" onClick={(e) => { e.preventDefault(); handleShare('instagram'); }} style={{ color: '#E1306C' }}>
        <FaInstagram size={40} />
      </a>
      
      <a href="#" onClick={(e) => { e.preventDefault(); handleShare('linkedin'); }} style={{ color: '#0077B5' }}>
        <FaLinkedin size={40} />
      </a>
      
    
      
      <a href="#" onClick={(e) => { e.preventDefault(); handleShare('whatsapp'); }} style={{ color: '#25D366' }}>
        <FaWhatsapp size={40} />
      </a>

    </div>
    <div className="mx-auto p-6 rounded-2xl">
      <div 
        className="flex items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
        style={{ color: '#fff', marginLeft: '40px' }}
      >
        <h2 className="font-bold mb-4">About Us</h2>
        <span className="ml-2">
          {isOpen ? <FaChevronUp style={{marginBottom : '10px'}}/> : <FaChevronDown style={{marginBottom: '100px'}}/>}
        </span>
      </div>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ease-in-out `}
      >
       {isOpen&& <p 
          style={{ color: '#fff', width: '90vw', marginLeft: '40px' }} 
          className="leading-relaxed"
        >
          This website helps you shorten long links and create QR codes quickly and easily. It's perfect for sharing clean, short URLs on social media, in emails, or even in print. Just paste your long URL and click the <strong>"short Now"</strong> button. In seconds, you'll get a short link and a QR code. You can copy the link or download the QR code to share it wherever you need. All your links and Download QR codes are saved securely, so you can access them again later. Our goal is to make link sharing simple, fast, and accessible for everyone—no technical skills needed.
        </p>}
      </div>
    </div>
    
    </div>
  );
}

export default Main;
